var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirculoNegado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42210b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 43subtabla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22.5A10.5,10.5,0,1,1,22.5,12,10.5,10.5,0,0,1,12,22.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 11,
    width: 12,
    height: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculoNegado);
export default __webpack_public_path__ + "static/media/circulo-negado.0f4f589aed821ca76b08033acafeaecc.svg";
export { ForwardRef as ReactComponent };